import axiosInstance from "./AxiosConfig";

class AccountManager {
  async CreateAccountManager(data) {

    try {
      const response = await axiosInstance.post("/accountManager/create", data);
      return response.data;
    } catch (error) {
      console.error(error);
      return error.response.data;
    }
  }

  async GetAllAccountManager() {
    try {
      const response = await axiosInstance.get("/accountManager/get");
      console.log("Get All response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetByID(id) {
    try {
      const response = await axiosInstance.get(`/accountManager/getbyid/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateById(id, data) {

    try {
      const response = await axiosInstance.put(
        `/accountManager/update/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return error.response.data;
    }
  }

  async DeleteById(id) {
    try {
      const response = await axiosInstance.delete(
        `/accountManager/delete/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  
  async getUserByEmailId(id) {
    try {
      const response = await axiosInstance.get(`/accountManager/getAccountByEmailId?email=${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAccountByLoginType(loginType) {
    try {
      const response = await axiosInstance.get(`/accountManager/getByLoginType?loginType=${loginType}`);
      console.log("Get All response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new AccountManager();
